const dummyUserDataFromDb = {
    "_id": "63da71831228d01c104f476f",
    "leadInfo": {
        "disqualificationObj": {
            "disqualified": false,
            "disqualificationReason": "",
            "disqualifiedById": null,
            "disqualifiedOn": "",
            "disqualifiedModel": "User",
            "disqualifiedByName": ""
        },
        "onHoldObj": {
            "onHold": false,
            "onHoldStage": "",
            "onHoldReason": "",
            "onHoldById": null,
            "onHoldOn": "",
            "nextFollowUpDate": "",
            "onHoldModel": "User",
            "onHoldByName": ""
        },
        "audit": {
            "status": "Audited",
            "auditedBy": {
                "name": "Vishnu V Nair",
                "id": {
                    "$oid": "628f53b3c8deb837b3306c77"
                }
            },
            "auditedAt": "2023-03-10T12:54:32+05:30",
            "auditId": {
                "$oid": "640adb3086757f0905d9450c"
            }
        },
        "associatedWithProjects": [
            {
                "$oid": "634d34908d1bd908f48b315a"
            }
        ],
        "isActive": true,
        "isBulkUpload": false,
        "eligibleToAssign": false,
        "deleted": false,
        "notification": "",
        "numberOfDays": 3,
        "profileCompeletion": 100,
        "status": "Active",
        "inModel": "User",
        "isGeneratedByLearningApp": false,
        "assignTo": {
            "$oid": "615ecdadedf40b7deead2a12"
        },
        "userType": "swavalamban-fellows",
        "commentInfo": [],
        "isIvrs": false,
        "ivrsId": null,
        "milestone": "",
        "profileCreatedBy": {
            "$oid": "615ecdadedf40b7deead2a12"
        },
        "profileCreatedByModel": "User",
        "starred": false,
        "updatedAt": "2024-04-03T09:09:44.937Z",
        "updatedBy": {
            "$oid": "615ecdadedf40b7deead2a12"
        },
        "updatedByModel": "User",
        "_id": {
            "$oid": "63da71831228d01c104f4770"
        },
        "paymentClaim": {
            "status": "Claimed and Settled"
        },
        "createdAt": "2023-02-01T19:34:51+05:30"
    },
    "mailInfo": {
        "send": false,
        "type": 0,
        "sendAt": null,
        "_id": {
            "$oid": "63da71831228d01c104f4768"
        }
    },
    "basic": {
        "address": {
            "line2": "",
            "city": "Vikarabad",
            "block": "Vikarabad",
            "district": "Vikarabad",
            "state": "Telangana",
            "line1": "vikarabad",
            "country": "India"
        },
        "nativeOf": {
            "city": "Vikarabad",
            "district": "Vikarabad",
            "state": "Telangana"
        },
        "email": "",
        "employer": "",
        "altMobileNumber": "",
        "identityType": [
            "Aadhaar"
        ],
        "source": "Agent",
        "dob": "1973-02-08T14:07:28.204Z",
        "gender": "Female",
        "educationalQualification": "Uneducated",
        "specializationOfEducation": "",
        "religion": "Hinduism",
        "category": "OBC",
        "pwd": "No",
        "employmentStatus": "Unemployed",
        "currentAnnualIncome": "Under INR 25000",
        "experience": "5",
        "_id": {
            "$oid": "63da71831228d01c104f4771"
        },
        "mobileNumber": "7013449983",
        "name": "E.Balamani",
        "phase": "Scale-up",
        "creditLinked": false,
        "pincode": 501101,
        "generatedThrough": "Visit",
        "addedBy": {
            "$oid": "615ecdadedf40b7deead2a12"
        },
        "identityNumber": "",
        "numberOfDependents": 2,
        "numberOfFamilyMember": 3
    },
    "familyAndAsset": {
        "area": {
            "value": "",
            "unit": ""
        },
        "hasBankAccount": false,
        "bankAccounts": [],
        "bankIFSC": "SBIN0020094",
        "proximityToBank": "",
        "landOwnerName": "",
        "loanType": "",
        "loansInstallmentStatus": "",
        "loanBanks": [],
        "receivedBankLoan": "Never taken a loan",
        "receivedLoanProviderType": "",
        "outstandingLoanAmount": null,
        "collateral": false,
        "numberOfFamilyMember": 3,
        "numberOfDependents": 2,
        "backgroundAndStability": "Stable (Ownership of assets (house/land/shop) by individual/family)",
        "ancestralHistoryOfWorkingInWhichSector": "",
        "familyBackground": "Different sector",
        "experienceInSector": "2",
        "hasLand": false,
        "relationshipWithLandOwner": "",
        "hasOtherAssets": [],
        "genuinenessAndHumility": "Very genuine and humble",
        "confidenceAsSwavalambi": "Moderate",
        "_id": {
            "$oid": "63da71831228d01c104f476a"
        },
        "collateralType": []
    },
    "enterpriseStatus": {
        "hasABusinessIdea": "One",
        "appliedForEnterpriseLoanBefore": false,
        "bankName": [],
        "statusOfEnterpriseLoan": "",
        "loanSizeCategory": "",
        "canSelfFinanceTheCapitalRequiredUpToINR": "5000",
        "loanAmountRequired": 50000,
        "financeType": "Bank Loan required",
        "loanProviderType": "",
        "_id": {
            "$oid": "63da71831228d01c104f476b"
        },
        "businessIdeas": [
            {
                "enterpriseIdea": "Stitching/embroidery/tailoring Shop (सिलाई / कढ़ाई / सिलाई की दुकान)",
                "enterpriseCategory": "Manufacturing",
                "ideaDetails": "yes",
                "heroIdea": true,
                "easeOfIdeaExecution": "Very easy (standard idea)",
                "confidenceOfDemand": "Moderate demand",
                "confidenceOfSupply": "Moderate supply of raw material",
                "requiresLand": false,
                "requiresSkills": true,
                "knowledgeLevel": "high",
                "supplyFiguredOut": false,
                "marketAccessFiguredOut": false,
                "_id": {
                    "$oid": "63da725a1228d01c104f4ac9"
                }
            }
        ],
        "creditLinked": false,
        "phase": "Scale-up"
    },
    "leadScoreAndSentiment": {
        "overallSentiment": "Enthusiastic",
        "tentativeHorizonToCloseThis": "3-6 months",
        "_id": {
            "$oid": "63da71831228d01c104f476c"
        }
    },
    "leadStrength": {
        "totalPoints": 0,
        "_id": {
            "$oid": "63da71831228d01c104f476d"
        }
    },
    "leadMaturity": {
        "dueDiligence": {
            "dueDiligenceStatus": "Completed",
            "inModel": "User",
            "questions": {
                "basic": {
                    "correctName": "Yes",
                    "interestedInBusiness": "No",
                    "financeType": "",
                    "isCandidateInvolvedInBusiness": "Yes",
                    "knowledgeOfBusiness": "",
                    "sourceOfKnowledge": "Referred by NGO",
                    "reasonForBusiness": "",
                    "skillTrainingRecommended": "",
                    "otherSourceOfInformation": "",
                    "licenseReqd": ""
                },
                "businessInfo": {
                    "businessLocationUnchanged": "",
                    "isExactBusinessLocationKnown": "No I will take more time",
                    "areTargetCustomersIdentified": "",
                    "estimateMonthlySalesAndCosts": "",
                    "nearbyCompetitiveBusinesses": "",
                    "goodsPurchaseLocation": ""
                },
                "existingenterpriserelated": {
                    "businessStartMonth": "",
                    "investmentInBusiness": "",
                    "hasGSTRegistration": "",
                    "hasGSTReturns": "",
                    "hasTINNumber": "",
                    "registeredUnderMSMEUdyogAadhar": "",
                    "hasRelevantLicenses": "",
                    "otherBusinessAssets": "",
                    "worthOfBusinessAsset": "",
                    "hasActiveBankAccount": "",
                    "avgMonthlyTransactionSize": "",
                    "maintainAccounts": "",
                    "havePurchaseInvoices": "",
                    "haveSalesInvoices": "",
                    "currentMonthlySales": "",
                    "currentMonthlyCosts": ""
                },
                "loanandfinancialinfo": {
                    "visitBankForLoan": "",
                    "receivedBankLoan": "",
                    "isCibilKnown": "",
                    "willSupplyQuotations": "",
                    "ownLand": "",
                    "willingToGiveCollateral": "",
                    "worthOfAsset": "",
                    "candidateHasPAN": "",
                    "candidateHasGuarantor": "",
                    "guarantorDetails": "",
                    "addGuarantor": "",
                    "bankAccounts": "",
                    "bankAccountIsActive": ""
                },
                "stabilityAndBackground": {
                    "earningFamilyMembers": "",
                    "monthlyHouseholdIncome": "",
                    "filedIncomeTax": "",
                    "incomeInITR": "",
                    "monthlyIndividualIncome": "",
                    "incomeSource": "",
                    "employmentStatus": "",
                    "employer": "",
                    "isOwnHouse": "",
                    "houseOwnerName": "",
                    "livingInHouse": ""
                },
                "eligibility": {
                    "setUp": "",
                    "familyTakenPmfLoan": "",
                    "businessIdea": "",
                    "educationalCertificate": "",
                    "purposeOfLoan": "",
                    "cibilScore": "",
                    "lastYearTurnOver": "",
                    "loanHistory": "",
                    "WillingToGiveMargin": "",
                    "cibilReportDocument": "",
                    "whatKindOfCollateral": "",
                    "CalculateEmi": "",
                    "quotationForMachinery": "",
                    "StatusOfPlaceOfUnit": "",
                    "firstBankIFSC": "",
                    "secondBankIFSC": "",
                    "bankAccountIsActive": "",
                    "bankDistanceFromLocation": "",
                    "relationWithPrimaryBank": "",
                    "candidateVisitingBankWhenRequired": "",
                    "comfortableWithBankVisit": "",
                    "haveActiveFSSAI": ""
                }
            },
            "updatedOn": "2023-11-08T14:39:04+05:30",
            "updatedBy": {
                "$oid": "Monika Shukla"
            }
        },
        "skillTrained": {
            "skillTrainedStatus": "Skill training not required",
            "instituteType": "",
            "instituteName": "",
            "instituteLocation": "",
            "inModel": "User",
            "updatedOn": "2023-02-01T19:38:26+05:30",
            "updatedBy": {
                "$oid": "615ecdadedf40b7deead2a12"
            }
        },
        "enterpriseTrained": {
            "enterpriseTrainedStatus": "EDP not required",
            "instituteType": "",
            "instituteName": "",
            "instituteLocation": "",
            "inModel": "User",
            "updatedOn": "2023-02-01T19:38:26+05:30",
            "updatedBy": {
                "$oid": "615ecdadedf40b7deead2a12"
            }
        },
        "businessPlanReady": {
            "quotationsObj": {
                "quotationStatus": "Not required",
                "quotations": []
            },
            "businessPlanReadyStatus": "Completed",
            "businessPlanStatus": "Completed",
            "businessPlanName": "",
            "businessPlanUrl": "https://assets.letsendorse.com/Swati/maturity/business-plan/63da71831228d01c104f476f/MjGcUWdHDE-photo.pdf",
            "businessPlanVerification": null,
            "createdByModel": "User",
            "inModel": "User",
            "createdAt": "2023-02-01T19:38:26+05:30",
            "createdBy": {
                "$oid": "615ecdadedf40b7deead2a12"
            },
            "updatedOn": "2024-04-03T14:39:44+05:30",
            "updatedBy": {
                "$oid": "5e2fb340caa96c5efc692da7"
            }
        },
        "capitalFulfilled": {
            "capitalFulfilledStatus": "Disbursed",
            "inModel": "User",
            "loanApplicationDetails": [
                {
                    "schemeId": {
                        "$oid": "5fc65623101d6138f4dc52e9"
                    },
                    "appliedToBank": "",
                    "branchIFSC": "",
                    "disbursedTo": "Candidate",
                    "importantInfo": "nulm",
                    "files": [],
                    "proofOfSanction": [
                        "https://assets.letsendorse.com/Swati/maturity/capital-fulfilled/63da71831228d01c104f476f/ITprxsdytg-photo.pdf"
                    ],
                    "proofOfDisbursement": [
                        "https://assets.letsendorse.com/Swati/maturity/capital-fulfilled/63da71831228d01c104f476f/pzzgOuUQJd-photo.pdf"
                    ],
                    "mfiId": "",
                    "mfiName": "",
                    "history": [],
                    "_id": {
                        "$oid": "63da72e81228d01c104f4e82"
                    },
                    "scheme": "National Urban Livelihoods Mission (NULM) - Individual Enterprises (SEP-I)",
                    "modeOfApplication": "Offline",
                    "dateOfApplication": {
                        "$date": "2022-10-05T18:30:00.000Z"
                    },
                    "dateOfSanction": {
                        "$date": "2022-10-27T18:30:00.000Z"
                    },
                    "dateOfDisbursement": {
                        "$date": "2022-10-27T18:30:00.000Z"
                    },
                    "dateOfRejection": null,
                    "status": "Disbursed",
                    "disbursedAmount": 50000,
                    "disbursedInterestPercentage": 10,
                    "slNo": 1
                }
            ],
            "updatedOn": "2023-02-01T19:40:48+05:30",
            "updatedBy": {
                "$oid": "615ecdadedf40b7deead2a12"
            }
        },
        "enterpriseSetup": {
            "officeShopFactoryAddressUrl": {
                "latitude": "17.366752",
                "longitude": "77.942768",
                "url": "https://maps.google.com/maps?q=17.366752,77.942768"
            },
            "kycDocuments": {
                "pan": "FERPB0521R",
                "aadhar": "409565203118",
                "udyogAadhar": ""
            },
            "entrepreneurStoryVerification": {
                "verifiedBy": {},
                "status": "Unverified"
            },
            "enterpriseSetupStatus": "Scaled up",
            "entityName": "Balamani Tailoring Center ",
            "entityType": "Proprietorship",
            "enterpriseState": "Scale-up",
            "enterpriseRegistered": "Yes",
            "udyogAadharCertificateReceived": "No",
            "udyogAadharCertificateUrl": "",
            "gstCertificate": "No",
            "gstCertificateUrl": "",
            "certificateOfShopAndEstablishmentAct": "No",
            "certificateOfShopAndEstablishmentActUrl": "",
            "officeShopFactoryAddress": "Pathur, Telangana 501111",
            "otherLicenses": "No",
            "otherLicensesUrl": "",
            "digitalPayment": "Yes",
            "hasInsurance": "No",
            "gemsPortalRegistered": "No",
            "bankName": "State Bank of India",
            "bankAccountNum": "62109666783",
            "bankIFSC": "SBIN0020094",
            "supportReceived": [
                "Counselling and Guidance",
                "Location Selection",
                "Securing necessary licenses",
                "Credit Linkage",
                "Machinery/Material Procurement"
            ],
            "recognizedSupport": "Raziya Sulthana (Triveni Educational and Rural Development Society)",
            "entrepreneurStory": "BALAMANI",
            "createdOn": "2022-11-03",
            "otherImageUrls": [
                "https://assets.letsendorse.com/Swati/maturity/enterprise-setup/63da71831228d01c104f476f/asvLYuJjcd-photo.jpeg"
            ],
            "creationMonth": "",
            "creationYear": "",
            "inModel": "User",
            "updatedOn": "2023-11-08T14:48:14+05:30",
            "updatedBy": {
                "$oid": "Monika Shukla"
            },
            "googleBusinessLocationUrl": "https://www.google.com/maps/place/17%C2%B022'00.3%22N+77%C2%B056'34.0%22E/@17.366752,77.9405793,17z/data=!3m1!4b1!4m5!3m4!1s0x0:0x5003b1837f62f81c!8m2!3d17.366752!4d77.942768",
            "markedStartedUpOn": {
                "$date": "2023-02-01T14:40:09.456Z"
            },
            "sidbiMilestone": "Milestone 15"
        },
        "enterpriseSustainability": {
            "enterpriseSustainabilityStatus": "Operational",
            "inModel": "User",
            "checkIns": [
                {
                    "index": 0,
                    "checkInDate": "2023-09-25",
                    "assessedBy": "Monika Shukla",
                    "modeOfAssessment": "Call",
                    "operational": "Operational",
                    "dailyProfit": "500",
                    "businessHealth": "Growing Revenue",
                    "jobsCreated": "4",
                    "developments": "",
                    "scaleupLoanReqd": "Yes",
                    "reqdLoanValue": 0,
                    "comments": "",
                    "creditScore": "",
                    "creditScoreDoc": null
                }
            ],
            "updatedOn": "2023-09-26T11:18:06+05:30",
            "updatedBy": {
                "$oid": "Monika Shukla"
            }
        },
        "_id": {
            "$oid": "63da71831228d01c104f476e"
        }
    },
    "__v": 0,
    "existingBusinessDetails": {
        "businessStartMonth": "05/2022",
        "registrationProof": [
            "Trade license"
        ],
        "salesFigures": 15500,
        "salesFigureUpdated": "01/02/2023",
        "proofOfSalesAndPurchase": "No proof",
        "filesIT": "No",
        "hasGstRegistration": "No",
        "bankAccountActive": "No",
        "businessBankAccountType": "No Bank account",
        "issuesCheques": "No",
        "averageMonthlyTxnSize": "Under INR 25000",
        "maintainAccountBooks": "No",
        "businessPremisesOwnership": "Own",
        "premisesArea": 150
    },
    "projectId": "634d34908d1bd908f4b315a",
    "leadId": "63da71831228d01104f476f"
};

export default dummyUserDataFromDb;